
import React from 'react';

const MentalHealthUnderline = () => {

	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='49'
			height='48'
			fill='none'
			viewBox='0 0 49 48'
		>
			<g fill='#2d2d2d' clipPath='url(#clip0)'>
				<path d='M32.001 39.002h-3v-4.5c0-1.65 1.35-3 3-3h4.5v-6c0-.825.675-1.5 1.5-1.5h1.005c.24 0 .36-.15.405-.24a.482.482 0 000-.48l-2.73-4.515a1.435 1.435 0 01-.21-.705c-.36-6.96-6.27-12.375-13.275-12.06-6.66.3-12.12 5.955-12.195 12.615a12.74 12.74 0 005.535 10.65 4.482 4.482 0 011.965 3.705v6.03h-3v-6.03c0-.495-.24-.945-.66-1.23a15.748 15.748 0 01-6.84-13.155c.09-8.235 6.84-15.21 15.045-15.57 8.445-.39 15.735 6.12 16.38 14.52l2.535 4.2c.66 1.08.675 2.4.06 3.495a3.39 3.39 0 01-2.535 1.725v4.545c0 1.65-1.35 3-3 3h-4.5v4.5h.015z'></path>
				<path d='M26 27h-4.5c-.825 0-1.5-.675-1.5-1.5v-3h-3c-.825 0-1.5-.675-1.5-1.5v-4.5c0-.825.675-1.5 1.5-1.5h3v-3c0-.825.675-1.5 1.5-1.5H26c.825 0 1.5.675 1.5 1.5v3h3c.825 0 1.5.675 1.5 1.5V21c0 .825-.675 1.5-1.5 1.5h-3v3c0 .825-.675 1.5-1.5 1.5zm-3-3h1.5v-3c0-.825.675-1.5 1.5-1.5h3V18h-3c-.825 0-1.5-.675-1.5-1.5v-3H23v3c0 .825-.675 1.5-1.5 1.5h-3v1.5h3c.825 0 1.5.675 1.5 1.5v3zM36.5 45H14v3h22.5v-3z'></path>
			</g>
			<defs>
				<clipPath id='clip0'>
					<path fill='#fff' d='M0 0H48V48H0z' transform='translate(.5)'></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default MentalHealthUnderline;
